import { useSelector } from 'react-redux';
import { selectIsMobileLayout } from '../../../../selectors/layout';
import { useDeviceCondition } from '../../../../hooks';
import { UIHeading2, UIHeading3, UIText1, UIText2 } from '@cian/ui-kit';
import { PromotionSectionHeaderLayout } from '../PromotionSectionHeaderLayout';
import * as React from 'react';
import { getHeaderTexts } from './utils';
import { selectExperiments } from '../../../../selectors/experiments';
import { allExperiments } from '../../../../constants/experiments';

export const PromotionSectionHeader = () => {
  const isMobile = useSelector(selectIsMobileLayout);
  const experiments = useSelector(selectExperiments);

  const Header = useDeviceCondition(UIHeading2, UIHeading3);
  const Subheader = useDeviceCondition(UIText2, UIText1);

  const { subtitle, title } = getHeaderTexts(experiments, allExperiments);

  return (
    <PromotionSectionHeaderLayout
      header={<Header>{title}</Header>}
      mobile={isMobile}
      subheader={<Subheader>{subtitle}</Subheader>}
    />
  );
};
